<template>
  <div class="ticket-create-new-ticket__container">
    <organism-ticket-create-new-incident
      v-if="!isLoading"
      :departmentList="departmentList"
      :priorityList="priorityList"
      :sourceList="sourceList"
      :topicList="topicList"
      :ticketData="ticketData"
      :escalation="escalationSelected"
      :escalationDetail="escalationDetail"
      :escalationTemplateList="escalationTemplateList"
      @changeEscalationTemplate="changeEscalationTemplate"
      @onSelectSite="getDepartmentListFromApi"
      @selectedTopicId="getTicketData"
      @createIncidentOrJob="createIncidentOrJob"
    ></organism-ticket-create-new-incident>
  </div>
</template>

<script>
import {
  getTopicList,
  getTopicById,
  createNewTicket,
  uploadTicketAttachments,
} from "@/api/api-module1"
import mixins from "@/mixins"
import OrganismTicketCreateNewIncident from "@/components/organisms/portal/internal/ticket/OrganismTicketCreateNewIncident.vue"
import mixinsSiteHelper from "@/mixins/mixinsSiteHelper"
import { getDepartmentListBySiteId } from "@/api/api-module-data"
import {
  getTicketEscalationActiveList,
  getTicketEscalationById,
} from "@/api/module-1/escalation"

export default {
  name: "TicketCreateNewIncident",
  components: { OrganismTicketCreateNewIncident },
  mixins: [mixins, mixinsSiteHelper],
  data() {
    return {
      // ticket detail
      departmentList: [],
      priorityList: [
        { id: "CRITICAL", name: "Critical" },
        { id: "HIGH", name: "High" },
        { id: "MEDIUM", name: "Medium" },
        { id: "LOW", name: "Low" },
      ],
      sourceList: [
        { id: "TICKET", name: "Ticket" },
        { id: "PHONE", name: "Phone" },
        { id: "EMAIL", name: "Email" },
        { id: "OTHER", name: "Other" },
      ],

      // ticket
      topicList: [],
      siteOptionList: [],
      ticketData: null,

      // escalation
      escalationTemplateList: null,
      escalationSelected: null,
      escalationDetail: {
        name: "",
        description: "",
        levels: [],
      },
      isLoading: true,
    }
  },
  async created() {
    await this.getTicketEscalationActiveList()
    await this.getDataFromApi()
  },
  methods: {
    // get data from api
    async getDataFromApi() {
      await Promise.all([this.getTopicListFromApi()])
      this.isLoading = false
    },

    // get department list
    async getDepartmentListFromApi(siteId) {
      this.showLoading(true)

      await getDepartmentListBySiteId(siteId)
        .then((departments) => {
          this.departmentList = departments.map((department) => {
            return {
              id: department.departmentId,
              name:
                department.departmentName +
                (department.isSupportDepartment ? " (Support)" : ""),
              isSupportDepartment: department.isSupportDepartment,
            }
          })
        })
        .finally(() => this.showLoading(false))
    },

    // get topic list
    async getTopicListFromApi() {
      this.showLoading(true)
      this.topicList = []

      await getTopicList()
        .then((topics) => {
          topics.forEach((topic) => {
            this.topicList.push({ id: topic.topicId, name: topic.topicName })
          })
        })
        .finally(() => this.showLoading(false))
    },

    // get ticket data
    async getTicketData(id) {
      this.showLoading(true)
      await getTopicById(id)
        .then((topic) => {
          this.ticketData = {
            topic: this.topicList.find((t) => t.id === topic.topicId),
            subject: topic.topicSubject,
            detail: topic.topicDetail,
          }
        })
        .finally(() => this.showLoading(false))
    },

    // create new incident
    async createIncidentOrJob(createTicket, uploadAttachment) {
      this.showLoading(true)

      await createNewTicket(createTicket)
        .then((ticket) => {
          if (ticket.status === "ok") {
            this.toastSuccess("Incident created successfully")

            if (uploadAttachment) {
              uploadTicketAttachments(
                ticket.data.ticketId,
                uploadAttachment
              ).then((attachment) => {
                if (attachment.status === "ok")
                  this.toastSuccess("Attachment uploaded successfully")
                else this.toastError("Attachment uploaded failed")
              })
              .catch(() => {
                  this.toastError(
                    "Attachment uploaded failed. Please check the file size of your attachment and try again."
                  )
              })
            }
            this.$router.push(
              `/internal/web-portal/ticket/${ticket.data.ticketId}`
            )
          } else this.toastError("Incident created failed")
        })
        .catch((error) => this.toastError(error))
        .finally(() => this.showLoading(false))
    },

    async getTicketEscalationActiveList() {
      this.showLoading(true)
      await getTicketEscalationActiveList()
        .then((response) => {
          this.escalationTemplateList = response.data
        })
        .finally(() => this.showLoading(false))
    },

    changeEscalationTemplate(optionSelected) {
      this.escalationSelected = optionSelected
      this.escalationDetail = {
        name: "",
        description: "",
        levels: [],
      }

      if (
        this.escalationSelected?.escalationId &&
        this.escalationTemplateList.length
      ) {
        this.getEscalationDetail(this.escalationSelected?.escalationId)
      }
    },

    async getEscalationDetail(escalationId) {
      this.showLoading(true)
      await getTicketEscalationById(escalationId)
        .then((response) => {
          this.escalationDetail = response
        })
        .finally(() => this.showLoading(false))
    },
  },
}
</script>

<style lang="scss" scoped>
.ticket-create-new-ticket__container {
  padding: 0 0 21px 0;
}
</style>
